





export const scrollbarStyle = {
    scrollbarWidth: 'auto',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px',
      backgroundColor: 'white',
    },
    '&::-webkit-scrollbar-thumb': {
      border:'2px solid white',
      backgroundColor: '#7E8B9A',
      borderRadius: '5px',
    },
};

